import FormattedMessage from 'I18n/components/FormattedMessage';
import { RefreshIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ReenrollmentView = ({
  flow
}) => {
  const {
    shouldReenroll
  } = flow;
  let message;
  if (shouldReenroll) {
    message = 'enrollment.canvas.reenrollOn';
  } else {
    message = 'enrollment.canvas.reenrollOff';
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Flex, {
      columnGap: "200",
      alignItems: "center",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(RefreshIcon, {
        color: "icon-primary-disabled"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })]
    })
  });
};
export default ReenrollmentView;